module.exports = __webpack_public_path__ + "static/media/lil_meatball_dance.acfa2455.mp4";